var MessageDirection;
(function (MessageDirection) {
    MessageDirection["IN"] = "IN";
    MessageDirection["OUT"] = "OUT";
})(MessageDirection || (MessageDirection = {}));
/**
 * The sorting mode of the paginated messages list
 */
var SortingMode;
(function (SortingMode) {
    SortingMode["OLDEST_FIRST"] = "OLDEST_FIRST";
    SortingMode["NEWEST_FIRST"] = "NEWEST_FIRST";
})(SortingMode || (SortingMode = {}));
/**
 * Platform event types
 */
var PlatformEventTypes;
(function (PlatformEventTypes) {
    PlatformEventTypes["INCOMING_PLATFORM_MESSAGE"] = "INCOMING_PLATFORM_MESSAGE";
    PlatformEventTypes["OUTGOING_PLATFORM_MESSAGE"] = "OUTGOING_PLATFORM_MESSAGE";
    PlatformEventTypes["READ_UPDATE_PLATFORM_MESSAGE"] = "READ_UPDATE_PLATFORM_MESSAGE";
    PlatformEventTypes["DELETED_PLATFORM_MESSAGE"] = "DELETED_PLATFORM_MESSAGE";
    PlatformEventTypes["DELETED_PLATFORM_CONVERSATION"] = "DELETED_PLATFORM_CONVERSATION";
    PlatformEventTypes["DELIVERY_STATUS"] = "DELIVERY_STATUS";
    PlatformEventTypes["READ_UPDATE_CONVERSATION"] = "READ_UPDATE_CONVERSATION";
})(PlatformEventTypes || (PlatformEventTypes = {}));

export { MessageDirection, PlatformEventTypes, SortingMode };
